module.exports = __webpack_public_path__ + "static/img/icon-green.6af1418d.png";